export default __webpack_public_path__ + "static/media/chademo.f26b1527.png";